(function (root) {
  const ADULT_TAG = '18-plus';

  // All complementary (hand-picked) results first, then related (automatic) ones,
  // keeping seed order inside each group.
  function pickSuggestions({ seedResults, cartProductIds, cartHasAdult, limit }) {
    const inCart = new Set((cartProductIds || []).map(Number));
    const seen = new Set();
    const ordered = [];
    (seedResults || []).forEach((r) => ordered.push(...((r && r.complementary) || [])));
    (seedResults || []).forEach((r) => ordered.push(...((r && r.related) || [])));

    const out = [];
    for (const product of ordered) {
      if (!product || seen.has(product.id)) continue;
      seen.add(product.id);
      if (inCart.has(Number(product.id))) continue;
      if (!product.available) continue;
      const tags = (product.tags || []).map((t) => String(t).toLowerCase());
      if (!cartHasAdult && tags.includes(ADULT_TAG)) continue;
      out.push(product);
      if (out.length >= limit) break;
    }
    return out;
  }

  function withDelimiters(cents, precision, thousands, decimal) {
    const [whole, frac] = (cents / 100).toFixed(precision).split('.');
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return frac ? grouped + decimal + frac : grouped;
  }

  function formatMoney(cents, format) {
    const template = format || '{{amount}}';
    const match = /\{\{\s*(\w+)\s*\}\}/.exec(template);
    const values = {
      amount: withDelimiters(cents, 2, ',', '.'),
      amount_no_decimals: withDelimiters(cents, 0, ',', '.'),
      amount_with_comma_separator: withDelimiters(cents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: withDelimiters(cents, 0, '.', ','),
    };
    const value = (match && values[match[1]]) || values.amount;
    return template.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  const api = { ADULT_TAG, pickSuggestions, formatMoney };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.CartUpsellLogic = api;
})(typeof window !== 'undefined' ? window : globalThis);
